// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { avalanche as _avalanche } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the avalanche chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 43114
 * Chain Name: Avalanche
 * Default Block Explorer: https://snowtrace.io
 * Default RPC URL: https://api.avax.network/ext/bc/C/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { avalanche } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: avalanche,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const avalanche = createCommon({
	..._avalanche,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
